import { render, staticRenderFns } from "./PoweredByTC.vue?vue&type=template&id=31738300&"
import script from "./PoweredByTC.vue?vue&type=script&lang=js&"
export * from "./PoweredByTC.vue?vue&type=script&lang=js&"
import style0 from "./PoweredByTC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports